import request from '../utils/csrf-superagent';
import config from '../config';
import actions from '../actions/actions';
import softwareDetailsActions from '../actions/softwareDetails';
import {MERCHANT_OF_RECORD, USER_TYPE} from '../utils/constants';

function navigateByBusinessModel(store, businessModel) {
    if (businessModel === MERCHANT_OF_RECORD.EG) {
        store.dispatch(actions.changeAppState('PAYOUT_DETAILS'));
    } else {
        store.dispatch(actions.changeAppState('LISTING_MODEL'));
    }
}

function postAndNavigate(store, systemId, businessModel, advertiserId) {
    request.post(`/${config.url_prefix}/api/advertiser/businessModel`)
        .send({ systemId, businessModel, advertiserId })
        .end((updateError) => {
            store.dispatch(actions.enableLoadOverLay(false));
            if (updateError) {
                store.dispatch(softwareDetailsActions.alertError('ipmob.internal.server.error'));
                return;
            }
            navigateByBusinessModel(store, businessModel);
        });
}

function resolveForSWSwitchIPM(store, systemId, advertiserId) {
    const advertiserBusinessModel = store.getState().businessModel?.advertiserBusinessModel;

    request.get(`/${config.url_prefix}/api/getPreferredBusinessModel?systemId=${systemId}`)
        .end((prefError, prefResponse) => {
            if (prefError) {
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(softwareDetailsActions.alertError('ipmob.internal.server.error'));
                return;
            }

            try {
                const { businessModel: preferredBusinessModel } = JSON.parse(prefResponse.text);

                if (!preferredBusinessModel) {
                    store.dispatch(actions.enableLoadOverLay(false));
                    store.dispatch(softwareDetailsActions.alertError('ipmob.error.process.request'));
                    return;
                }

                if (advertiserBusinessModel === MERCHANT_OF_RECORD.EG) {
                    // IPM = MOR
                    if (preferredBusinessModel === MERCHANT_OF_RECORD.SUPPLIER) {
                        // PMSC supports Agency only → Ineligible
                        store.dispatch(actions.enableLoadOverLay(false));
                        // TODO: update ineligible page to reflect agency only ineligibility for MOR IPM
                        store.dispatch(actions.showIneligibleForm('AGENCY_ONLY_INELIGIBILITY'));
                    } else {
                        // PMSC supports MOR only, or both and prefers MOR/undefined → set MOR
                        postAndNavigate(store, systemId, MERCHANT_OF_RECORD.EG, advertiserId);
                    }
                } else if (preferredBusinessModel === MERCHANT_OF_RECORD.UNSPECIFIED) {
                    // IPM = Agency
                    // PMSC supports both, no preference → let user choose
                    store.dispatch(actions.enableLoadOverLay(false));
                    store.dispatch(actions.changeAppState('BUSINESS_MODEL'));
                } else {
                    // IPM = Agency
                    // PMSC supports Agency only (SUPPLIER) → Agency
                    // PMSC supports MOR only (EG) → MOR
                    // PMSC supports both, prefers MOR or Agency → follow preference
                    postAndNavigate(store, systemId, preferredBusinessModel, advertiserId);
                }
            } catch (exp) {
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(softwareDetailsActions.alertError('ipmob.error.process.request'));
            }
        });
}

function resolveForNetNewAndPPM(store, systemId, advertiserId) {
    request.get(`/${config.url_prefix}/api/getPreferredBusinessModel?systemId=${systemId}`)
        .end((error, response) => {
            if (error) {
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(softwareDetailsActions.alertError('ipmob.internal.server.error'));
                return;
            }

            try {
                const { businessModel } = JSON.parse(response.text);

                if (!businessModel) {
                    store.dispatch(actions.enableLoadOverLay(false));
                    store.dispatch(softwareDetailsActions.alertError('ipmob.error.process.request'));
                    return;
                }

                if (businessModel === MERCHANT_OF_RECORD.UNSPECIFIED) {
                    store.dispatch(actions.enableLoadOverLay(false));
                    store.dispatch(actions.changeAppState('BUSINESS_MODEL'));
                } else {
                    postAndNavigate(store, systemId, businessModel, advertiserId);
                }

            } catch (exp) {
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(softwareDetailsActions.alertError('ipmob.error.process.request'));
            }
        });
}

function resolveBusinessModel(store, action) {
    const { systemId, advertiserId } = action.payload;
    const userType = store.getState().app?.userType;

    if (userType === USER_TYPE.IPM_SOFTWARE_SWITCH) {
        resolveForSWSwitchIPM(store, systemId, advertiserId);
    } else {
        resolveForNetNewAndPPM(store, systemId, advertiserId);
    }
}

export default resolveBusinessModel;
